import React, { useEffect } from 'react'
import { Modal, Radio, Select, Input } from 'antd'

const AddLocationModal = ({
  visible,
  onCancel,
  onOk,
  addLocationType,
  setAddLocationType,
  selectedBaseLocation,
  setSelectedBaseLocation,
  baseLocations,
  newLocationKey,
  newLocationDescription,
  setNewLocationDescription
}) => {
  return (
    <Modal
      visible={visible}
      title="Add New Location Reference"
      onCancel={onCancel}
      onOk={onOk}
      okText="Generate"
      cancelText="Cancel"
      centered
    >
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 8, fontWeight: 600 }}>
            Location Type:
          </label>
          <Radio.Group
            value={addLocationType}
            onChange={e => {
              setAddLocationType(e.target.value)
            }}
          >
            <Radio value="new">New Main Location</Radio>
            <Radio value="existing">Add to Existing Main Location</Radio>
          </Radio.Group>
        </div>

        {addLocationType === 'existing' && (
          <div style={{ marginBottom: 16 }}>
            <label
              style={{ display: 'block', marginBottom: 8, fontWeight: 600 }}
            >
              Select Base Location:
            </label>
            <Select
              style={{ width: '100%' }}
              placeholder="Select a main location"
              value={selectedBaseLocation}
              onChange={val => setSelectedBaseLocation(val)}
            >
              {baseLocations.map(base => (
                <Select.Option key={base} value={base}>
                  Location {base} ({`__location${base}.X__`})
                </Select.Option>
              ))}
            </Select>
          </div>
        )}

        <label style={{ display: 'block', marginBottom: 8, fontWeight: 600 }}>
          Location Key (Auto-generated):
        </label>
        <Input
          value={newLocationKey}
          disabled
          placeholder="__location1.1__"
          style={{ background: '#f5f5f5', color: '#555' }}
        />
        <div style={{ marginTop: 4, fontSize: '12px', color: '#888' }}>
          Format:{' '}
          <code
            style={{
              background: '#f5f5f5',
              padding: '2px 6px',
              borderRadius: 3
            }}
          >
            __locationX.Y__
          </code>{' '}
          where X is scene/location number and Y is variant number
        </div>
      </div>
      <div>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 600 }}>
          Description:
        </label>
        <Input.TextArea
          value={newLocationDescription}
          onChange={e => setNewLocationDescription(e.target.value)}
          rows={4}
          placeholder="Enter location description for image generation (e.g., A cozy coffee shop with wooden furniture and warm lighting)"
        />
      </div>
    </Modal>
  )
}

export default AddLocationModal
